import React from 'react';
import { useI18n, useCurrency } from '~Hooks';
import { HistoryOrder } from '../../index';
import { formatPaymentStatus } from '../../utils';

import {
  PaperTitle,
  Paper,
  PaymentRow,
  PaymentBlock,
  Border,
  CardDetail,
  CardDetailsWrapper,
  CardDetailsHeader,
} from './styles';

interface Props {
  order: HistoryOrder;
}

export const PaymentInfo = ({ order }: Props) => {
  const { i18n } = useI18n();
  const currency = useCurrency();
  const subPayments = order?.payment?.subPayments ?? [];

  return (
    <>
      <PaperTitle>
        {i18n('History.Payment')} {order.payment.type} -{' '}
        {formatPaymentStatus(order.payment.status, i18n)}
      </PaperTitle>
      <Paper>
        <PaymentRow>
          <PaymentBlock>{order.origin}</PaymentBlock>
          <PaymentBlock>
            {i18n('History.TotalAmount')}: {currency.format(order.payment.amount)}
          </PaymentBlock>
          <PaymentBlock>
            {i18n('History.TotalTip')}:{' '}
            {currency.format(order.payment.correctedTip ?? order.payment.tip)}
          </PaymentBlock>
        </PaymentRow>
        <PaymentRow>
          {order.payment?.metadata?.cardDetails?.maskedPan && order.payment.type !== 'MULTIPAY' && (
            <CardDetailsWrapper>
              <CardDetailsHeader>{i18n('History.CardDetails')}</CardDetailsHeader>
              {Object.entries(order.payment.metadata.cardDetails).map(([key, value]) => {
                if (key === '__typename') {
                  return;
                }

                if (key === 'cardType') {
                  value = `${i18n('Receipt.CardType')}: ${value}`;
                }

                if (['tsi', 'tvr', 'aid'].includes(key) && value) {
                  value = `${key.toUpperCase()}: ${value}`;
                }

                return <CardDetail key={key}>{value}</CardDetail>;
              })}
            </CardDetailsWrapper>
          )}
        </PaymentRow>
        {!!subPayments.length && (
          <>
            <Border />
            {subPayments.map((sb) => (
              <PaymentRow key={sb.id}>
                <PaymentBlock>{sb.type}</PaymentBlock>
                <PaymentBlock>
                  {i18n('History.Amount')}: {currency.format(sb.amount)}
                </PaymentBlock>
                <PaymentBlock>
                  {i18n('History.Tip')}: {currency.format(sb.correctedTip ?? sb.tip)}
                </PaymentBlock>
              </PaymentRow>
            ))}
          </>
        )}
      </Paper>
    </>
  );
};
